// extracted by mini-css-extract-plugin
module.exports = {"dynamicImageSlider":"DynamicImage_dynamicImageSlider__2wFGi","dynamicImage":"DynamicImage_dynamicImage__1KxiX","dynamicImageCards":"DynamicImage_dynamicImageCards__12EDZ"};